<script>
import { mapGetters } from 'vuex';
import Logo from '@/assets/logo/WhiteTextLogo.svg';
import Footer from '@/components/Footer.vue';

export default {
  name: 'LayoutMobile',

  components: {
    Logo,
    Footer,
  },

  computed: {
    ...mapGetters('ui', ['isLanding', 'isAdminView', 'routeLoaded']),
  },
};
</script>

<template>
  <v-app id="v-app">
    <!-- HOMEPAGE LAYOUT -->
    <div v-if="isLanding">
      <router-view />
    </div>

    <!-- ADMIN LAYOUT -->
    <div v-else-if="isAdminView">
      <router-view />
    </div>

    <!-- DEFAULT LAYOUT -->
    <div v-else-if="routeLoaded" class="mobile-grid">
      <header class="logo-header horizontal-header">
        <a class="logo-link" @click="$router.push('/')">
          <Logo class="logo" />
        </a>
      </header>

      <main class="main-container">
        <router-view />
      </main>

      <Footer class="footer" />
    </div>

    <div v-else></div>
  </v-app>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.mobile-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 120px 1fr auto;
  grid-template-areas:
    'header'
    'main'
    'footer';
  grid-gap: 1rem;
  align-content: flex-start;
  justify-items: center;
  min-height: 100vh;
  width: 100%;
}

.logo-header {
  grid-area: header;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0.5rem;
  background-image: url('~@/assets/backgrounds/BlueBackground.svg?external');
  background-repeat: no-repeat;
  background-size: 200%;
  background-position: bottom;
  box-sizing: border-box;
}

.logo-link {
  height: 100%;
  width: auto;
}

.logo {
  width: auto;
  height: 100%;
  min-height: 100%;
  fill: white;
  filter: $black-drop-shadow;
}

.main-container {
  grid-area: main;
  // height: 100vh;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  // padding-top: 60px;
  // overflow-y: overlay;
}

.footer {
  grid-area: footer;
}
</style>
